import { RadioGroup } from '@affine/component';
import type { DocMode } from '@blocksuite/affine/blocks';
import {
  DocsService,
  GlobalContextService,
  useLiveData,
  useService,
} from '@toeverything/infra';
import { useCallback, useEffect, useMemo } from 'react';

import { ViewService } from '../../services/view';
import { useActiveSidebar } from '../use-is-active-sidebar';
import { ViewSidebarTabIconTarget } from '../view-islands';
import * as styles from './sidebar-header-switcher.css';

// provide a switcher for active extensions
// will be used in global top header (MacOS) or sidebar (Windows)
export const SidebarHeaderSwitcher = () => {
  const view = useService(ViewService).view;
  const tabs = useLiveData(view.sidebarTabs$);
  /*DNB_FIX activeTabName вместо activeTab*/
  /*const activeTab = useLiveData(view.activeSidebarTab$);*/
  /*  DNB_FIX */
  const {
    RIGHT_SIDEBAR_TABS_ACTIVE_KEY,
    activeTabName,
    globalStateChange,
    isSharedMode,
  } = useActiveSidebar();

  const tabItems = tabs.map(tab => ({
    value: tab.id,
    label: (
      <ViewSidebarTabIconTarget
        className={styles.iconContainer}
        viewId={view.id}
        tabId={tab.id}
      />
    ),
    style: { padding: 0, fontSize: 20, width: 24 },
  }));

  //DNB_FIX share_mode
  const pageId = useLiveData(
    useService(GlobalContextService).globalContext.docId.$
  );
  const docMode = useLiveData(
    useService(GlobalContextService).globalContext.docMode.$
  );
  const currentMode = useLiveData(
    useLiveData(useService(DocsService).list.doc$(pageId as string))
      ?.primaryMode$
  );

  const mode = useMemo(() => {
    return docMode === ('full' as DocMode) ? currentMode : docMode;
  }, [currentMode, docMode]);

  const tabItemsShared = useMemo(() => {
    const tabItemsCopy = [...tabItems];
    return isSharedMode && mode === 'page'
      ? tabItemsCopy.filter(item => item.value === 'outline')
      : isSharedMode && mode === 'edgeless'
        ? tabItemsCopy.filter(item => item.value === 'frame')
        : tabItems;
  }, [mode, isSharedMode, tabItems]);

  const handleActiveTabChange = useCallback(
    (tabId: string) => {
      view.activeSidebarTab(tabId);
      /*  DNB_FIX */
      globalStateChange(RIGHT_SIDEBAR_TABS_ACTIVE_KEY, tabId);
    },
    [RIGHT_SIDEBAR_TABS_ACTIVE_KEY, globalStateChange, view]
  );
  /*  DNB_FIX */
  useEffect(() => {
    if (!activeTabName) return;
    view.activeSidebarTab(activeTabName);
  }, [activeTabName, view]);

  //DNB_FIX share_mode
  useEffect(() => {
    if (!isSharedMode) return;
    if (tabItemsShared.length === 0) return;
    globalStateChange(RIGHT_SIDEBAR_TABS_ACTIVE_KEY, tabItemsShared[0].value);
  }, [
    RIGHT_SIDEBAR_TABS_ACTIVE_KEY,
    globalStateChange,
    isSharedMode,
    tabItemsShared,
  ]);

  return tabItemsShared.length ? (
    <RadioGroup
      iconMode
      borderRadius={8}
      itemHeight={24}
      padding={4}
      gap={8}
      items={/* DNB_FIX share_mode */ tabItemsShared}
      value={/* DNB_FIX */ /* activeTab?.id */ activeTabName ?? 'outline'}
      onChange={handleActiveTabChange}
    />
  ) : null;
};
